import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { AcademicLabels } from "./academic.labels";

@TypeManagerDecorator("s25-ng-academic-coming-soon")
@Component({
    selector: "s25-ng-academic-coming-soon",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: "academic-coming-soon" },
    template: `
        <div class="academic-coming-soon__header">
            <h1>{{ title() }}</h1>
        </div>
        <section class="academic-coming-soon__card">
            <p>{{ labels.COMING_SOON }}</p>
        </section>
    `,
    styles: `
        :host {
            display: block;
            padding: 1.5rem 1.75rem 2rem;
        }

        .academic-coming-soon__header {
            margin-bottom: 1.5rem;
            padding-bottom: 1rem;
            border-bottom: 2px solid var(--color--border);
        }

        .academic-coming-soon__header h1 {
            margin: 0;
            color: var(--color--text-strong);
        }

        .academic-coming-soon__card {
            background: var(--color--surface-bg);
            border: 1px solid var(--color--border);
            border-radius: 12px;
            padding: 1.25rem 1.5rem;
            box-shadow: 0 1px 3px color-mix(in srgb, var(--color--text) 10%, transparent);
        }

        .academic-coming-soon__card p {
            margin: 0;
            color: var(--color--text-muted);
        }
    `,
})
export class AcademicComingSoonComponent {
    readonly labels = AcademicLabels;
    readonly titleKey = input.required<keyof typeof AcademicLabels>();
    readonly title = computed(() => AcademicLabels[this.titleKey()]);
}
